<template>
  <div v-if="loading || error" class="request-state" :role="error ? 'alert' : 'status'" :aria-busy="loading ? 'true' : 'false'">
    <p>{{ loading ? loadingText : error }}</p>
    <button v-if="!loading && error" type="button" class="request-retry" @click="$emit('retry')">Спробувати ще раз</button>
  </div>
</template>
<script>
export default { props: { loading: Boolean, error: String, loadingText: { type: String, default: "Завантажуємо…" } } };
</script>
<style scoped>
.request-state { padding: 16px; color: #333; font: 14px/20px Inter, sans-serif; }
.request-retry { margin-top: 8px; min-height: 44px; padding: 10px 16px; border: 1px solid #075a63; border-radius: 8px; background: #fff; color: #075a63; font: 600 14px/20px Inter, sans-serif; cursor: pointer; }
</style>
